<template>
	<div class="brick">
		<div class="list_top_box">
			<table border="0">
				<tr>
					<td>
						<div class="left_option">
							<em class="lt_text">Invoice Date</em>
							<span class="mgr_5"> <CustomDatePicker v-model="invoice_date_from"/> ~ <CustomDatePicker v-model="invoice_date_to"/></span>

							<em class="lt_text">S/O No</em>
							<span class="mgr_5"><SoSelect v-model.trim="so_dn" ph="Enter SO No" :backOrderMode="true" @set-invoice="setInvoice"/></span>

							<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="ship_to_code" ph="Ship To" :customerOnly="true" :showName="false" @set-partner="setPartner" /> </span>
							<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="bill_to_code" ph="Bill To" :customerOnly="true" :showName="false" @set-partner="setPartner" /> </span>

							<em class="lt_text">Sales Group</em>
							<span class="int_type_no_border mgr_10"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

							<!-- <span class="int_type sm_int"> <input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" /> </span> -->
						</div>
						<div class="left_option">
							<span class="int_type_no_border">
								<ItemSelectMulti v-model.trim="items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
							</span>
						</div>
						<div class="left_option" style="padding-top:2px;">
							<em class="lt_text">Item {{ headers.class }}</em>

							<span class="int_type half_int">
								<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'"> </autocomplete>
							</span>

							<span class="int_type_no_border mgr_5">
								<ItemClassSelectMulti v-model.trim="item_classes_string" />
							</span>
						</div>
						<div class="left_option" style="padding-top:2px;">
							<em class="lt_text">Item Color</em>
							<span class="int_type mgr_10">
								<input type="text" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" />
							</span>

							<template v-if="true">
								<em class="lt_text">On Hand ></em>
								<currency-input type="text" style="width:60px;" v-model.trim="on_hand_q" :precision="0" :allow-negative="false" class="int_type al_right" @focus="$event.target.select()" />
								<em class="lt_text mgr_10">Received Date</em>
								<span class="mgr_5"> <CustomDatePicker v-model="received_date_from"/> ~ <CustomDatePicker v-model="received_date_to"/></span>
							</template>

							<a href="javascript:;" class="search_bt" @click="search()">Search</a>
							<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
							<font color="red"><b>Takes long time without proper search condition(s) </b></font>
						</div>
					</td>
					<td v-if="user.company_id == 'beautyplus'">
						<div class="bottom_box" style="padding: 0px;">
							<table class="list_tbl">
								<colgroup>
									<col style="width: 34%;" />
									<col style="width: 33%;" />
									<col style="width: 33%;" />
								</colgroup>
								<thead>
									<tr>
										<th colspan="3">Over $300 BACK ORDER STORE LIST</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="bg_none" v-for="n in 3" v-bind:key="n">
											<a v-if="top_list[n - 1] && top_list[n - 1].ship_to_code" href="javascript:;" @click="setShipTo(top_list[n - 1].ship_to_code)">{{ top_list[n - 1].ship_to_code }}</a>
										</td>
									</tr>
									<tr>
										<td class="bg_none" v-for="n in 3" v-bind:key="n">
											<a v-if="top_list[n - 1] && top_list[n - 1].ship_to_code" href="javascript:;" @click="setShipTo(top_list[n - 1].ship_to_code)">{{ top_list[n + 2].ship_to_code }}</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<!-- <table class="view_tbl" border="1">
							<tr>
								<td colspan="3">Over $300 BACK ORDER STORE LIST</td>
							</tr>
							<tr>
								<td>H-482-5</td>
								<td>H-482-5</td>
								<td>H-482-5</td>
							</tr>
							<tr>
								<td>H-482-5</td>
								<td>H-482-5</td>
								<td>H-482-5</td>
							</tr>
						</table>
					</td> -->
					</td>
				</tr>
			</table>
		</div>

		<div class="fixed-table-container" style="padding-top:0px;">
			<div class="table-wrapper" style="height: 95%">
				<table class="list_tbl sticky_list_tbl">
					<thead>
						<tr>
							<th width="10px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
							<th width="50px;">Sales Code</th>
							<th width="100px;">Sales Name</th>
							<th width="60px;">Ship To</th>
							<th width="180px;">Ship To Name</th>
							<th width="60px;" v-if="user.company_id == 'newjigu'">Bill To</th>
							<th width="100px;" v-if="user.company_id == 'newjigu'">Bill To Name</th>
							<th v-if="user.company_id != 'newjigu'">Ship To Address</th>
							<th width="90px;">{{ headers.class }} Code</th>
							<th width="200px;">{{ headers.class }} Name</th>
							<th v-if="user.company_id != 'jc'" width="80px;">Color</th>
							<th width="100px;">S/O No</th>
							<th width="80px;" v-if="user.company_id == 'newjigu'">S/O Date</th>
							<th width="100px;">Inv. No</th>
							<th width="80px;">Inv. Date</th>
							<th width="60px;">Price</th>
							<th width="50px;">Order Qty.</th>
							<th width="50px;">Bill Qty.</th>
							<th width="50px;">Back Qty.</th>
							<th width="50px;">On-Hand</th>
							<th width="50px;">Avail</th>
							<template v-if="user.company_id == 'newjigu'">
								<th width="50px;">Pend30</th>
								<th width="50px;">Pend90</th>
							</template>

							<th width="50px;">Onboard</th>
							<th width="80px;">Arr Date.</th>
							<!-- 
					<th width="5%">Inv. Date</th>
					
					<th width="5%">S/O Date</th>
					
					<th width="6%">Bill To Code</th>
					<th width="8%">Bill To Name</th>
					
					<th width="7%">Total Amt.</th>
					<th width="5%">Box</th>
					<th width="25%">Remark</th> -->
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in items" v-bind:key="item.invoice_item_no">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_left">{{ item.sales_group_code }}</td>
							<td class="al_left">{{ item.sales_group_name }}</td>
							<td class="al_left">
								<a href="javascript:;" @click="gotoPartner(item.ship_to_code)">{{ item.ship_to_code }}</a>
							</td>
							<td class="al_left truncate" :title="item.ship_to_name">
								<a href="javascript:;" @click="gotoPartner(item.ship_to_code)">{{ item.ship_to_name }}</a>
							</td>
							<td class="al_left" v-if="user.company_id == 'newjigu'">
								<a href="javascript:;" @click="gotoPartner(item.bill_to_code)">{{ item.bill_to_code }}</a>
							</td>
							<td class="al_left truncate" v-if="user.company_id == 'newjigu'" :title="item.bill_to_name">
								<a href="javascript:;" @click="gotoPartner(item.bill_to_code)">{{ item.bill_to_name }}</a>
							</td>
							<td class="al_left truncate" v-if="user.company_id != 'newjigu'">{{ item.ship_to_address }}</td>
							<td class="al_left">{{ item.class_code }}</td>
							<td class="al_left truncate">
								<a href="javascript:;" @click="selectItem(item)">{{ item.class_name }}</a>
							</td>
							<td v-if="user.company_id != 'jc'" class="al_left" :style="item.active_yn == 'N' || item.so_blocked ? 'background-color: yellow;' : ''">
								<b v-if="item.active_yn == 'N'"><font color="red">!! </font></b><b v-if="item.so_blocked"><font color="red">B </font></b><a href="javascript:;" @click="selectColor(item)">{{ item.color_code }}</a>
							</td>
							<td class="al_left">
								<a href="javascript:;" @click="selectSO(item)">{{ item.so_dn }}</a>
							</td>
							<td class="al_left" v-if="user.company_id == 'newjigu'">{{ item.so_date }}</td>
							<td class="al_left">
								<a href="javascript:;" @click="selectInvoice(item)">{{ item.invoice_dn }}</a>
							</td>
							<td class="al_left">{{ item.invoice_date }}</td>
							<td class="al_right">{{ item.unit_price | toCurrency }}</td>
							<td class="al_right">{{ item.quantity | commaSeparated }}</td>
							<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
							<td class="al_right">
								<font color="red">{{ item.bo_quantity | commaSeparated }}</font>
							</td>
							<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
							<td class="al_right">{{ item.available_quantity | commaSeparated }}</td>
							<template v-if="user.company_id == 'newjigu'">
								<td class="al_right">{{ item.pending_30_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.pending_90_quantity | commaSeparated }}</td>
							</template>
							<td class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
							<td class="al_left">{{ item.arrival_date }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}, (Max {{ page_size }})</div>

		<Paging v-if="false" ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="view_bottom_bt">
			<input v-if="true" type="button" value="Copy" class="gray_bt" style="margin-left:5px;float:left" @click="copyItems()" />

			<a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="makeSalesOrder()">Make Sales Order</a>
			<a href="javascript:void(0);" class="gray_bt" @click="exportExcel()">Excel</a>
			<a href="javascript:void(0);" class="gray_bt" @click="printConfirm()">Print</a>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiInvoiceIndex, apiSelectBackOrderItemList, apiSelectBackOrderTopList } from '@/api/sales/invoice.js';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import SoSelect from '@/components/common/SoSelect';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
//import Modal from '@/components/common/Modal';
import { today, daysAgo } from '@/utils/date.js';
import { objectCopy, reportMrtUrl, reportRender, exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import _ from 'lodash';

export default {
	props: ['headers'],
	data: function() {
		return {
			backUri: '/',
			paging_yn: 'N',
			page_size: 500,
			page_no: 1,
			list_count: 0,

			invoice_date_from: daysAgo(7),
			invoice_date_to: today(),
			received_date_from: null,
			received_date_to: null,
			sales_group_code: null,
			ship_to_code: null,
			bill_to_code: null,
			//itemClasses: [],
			item_classes_string: '',
			item_classes: [],
			colors_string: '',
			colors: [],
			so_dn: null,
			keyword: null,
			on_hand_q: null,
			items_str: '',
			separator: ',',

			salesGroups: [],

			items: [],
			top_list: [],

			modalName: '',
			ship_or_bill: '',
			showModal: false,

			total_amount_sum: 0,

			allSelected: false,

			saveParam: {},
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		selected_items() {
			return this.items_str ? this.items_str.split(this.separator) : null;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
		ItemClassSelectMulti,
		ItemSelectMulti,
		SoSelect,
	},
	methods: {
		setShipTo(ship_to_code) {
			//console.log(ship_to_code);
			this.ship_to_code = ship_to_code;
			this.search();
		},
		copyItems() {
			//console.log('copy');
			if (this.items.filter(i => i.selected).length == 0) {
				this.$toast.error('No items selected');
				return;
			}
			if (this.items.filter(i => i.selected).length > 500) {
				this.$toast.error('Too many items');
				return;
			}

			var c_items = _.cloneDeep(this.items.filter(i => i.selected));
			c_items.forEach(function(i) {
				i.invoice_item_no = null;
				i.quantity_abs = i.bo_quantity;
			});

			if (c_items.length > 0) {
				this.$session.set('items', c_items);
				this.$toast.success('Item copied');
			}
		},

		async exportExcel() {
			const { data } = await apiSelectBackOrderItemList(this.saveParam);

			data.itemList.forEach(i => {
				i.bo_amount = i.bo_quantity * i.unit_price;
			});

			const headers = [
				{ key: 'sales_group_code', name: 'Sales Code', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Name', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_code', name: 'Ship To Code', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_name', name: 'Ship To Name', width: 15, dataType: defaultDataType.string },
				{ key: 'class_code', name: 'Class Code', width: 15, dataType: defaultDataType.string },
				{ key: 'class_name', name: 'Class Name', width: 15, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
				{ key: 'so_dn', name: 'S/O No.', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Inv. No.', width: 15, dataType: defaultDataType.string },
				{ key: 'unit_price', name: 'Price', width: 10, dataType: defaultDataType.currency },
				{ key: 'quantity', name: 'Order Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'available_quantity', name: 'Avail', width: 15, dataType: defaultDataType.currency },
				{ key: 'shipped_quantity', name: 'Bill Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'bo_quantity', name: 'Back Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'on_hand', name: 'On Hand', width: 15, dataType: defaultDataType.currency },
				{ key: 'on_board_quantity', name: 'On Board', width: 15, dataType: defaultDataType.currency },
				{ key: 'arrival_date', name: 'Arr. Date', width: 15, dataType: defaultDataType.string },
			];

			if (this.user.company_id == 'newjigu') {
				let idx = headers.findIndex(h => h.key === 'class_code');
				headers.splice(idx, 0, { key: 'bill_to_code', name: 'Bill To Code', width: 15, dataType: defaultDataType.string });

				idx = headers.findIndex(h => h.key === 'unit_price');
				headers.splice(idx, 0, { key: 'invoice_date', name: 'Invoice Date', width: 15, dataType: defaultDataType.string });

				idx = headers.findIndex(h => h.key === 'on_hand');
				headers.splice(idx, 0, { key: 'bo_amount', name: 'Back Amount', width: 10, dataType: defaultDataType.currency });
			}

			exportDataExcel(data.itemList, headers, 'Back Order Item List');
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += this.separator + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
			//this.itemClass = c.selectedObject.code;
			//this.search();

			//console.log(c.selectedObject.code);
		},
		setPartner() {
			this.search();
		},
		makeSalesOrderConfirm(items) {
			var ship_to_count = 0;
			var selected_ship_to_code = null;
			var selected_invoice_item_nos = [];
			items.forEach(i => {
				selected_invoice_item_nos.push(i.invoice_item_no);
				if (ship_to_count == 0 || selected_ship_to_code != i.ship_to_code) {
					ship_to_count++;
					selected_ship_to_code = i.ship_to_code;
				}
			});

			if (ship_to_count > 1) {
				this.$toast.error('Multiple partners are selected');
				return;
			}

			//console.log(selected_ship_to_code, selected_invoice_item_nos);

			//this.$router.push({ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, ship_to_code: selected_ship_to_code, invoice_item_nos: selected_invoice_item_nos.join() } });
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, ship_to_code: selected_ship_to_code, invoice_item_nos: selected_invoice_item_nos.join() } });
			window.open(routeData.href, 'bo_herp_so');
		},
		makeSalesOrder() {
			var selected_items = this.items.filter(i => i.selected);
			if (selected_items.filter(i => i.active_yn == 'Y' && !i.so_blocked).length == 0) {
				this.$toast.error('No valid items selected.');
				return;
			}

			if (selected_items.filter(i => i.active_yn == 'N' || i.so_blocked).length > 0) {
				//this.$toast.error('In-active or blocked item(s) included.');
				//this.$alertify.alert('Alert', 'In-active or blocked item(s) included.');

				var item_list_str = '';
				selected_items
					.filter(i => i.active_yn == 'N' || i.so_blocked)
					.forEach(i => {
						item_list_str += i.class_code + ' ' + i.color_code + '<br/>';
					});

				this.$alertify.confirm('In-Active or Blocked item(s) will be excluded. Proceed? <br/><br/>Invalid Item List<br/><br/>' + item_list_str, () => {
					this.makeSalesOrderConfirm(selected_items.filter(i => i.active_yn == 'Y' && !i.so_blocked));
				});

				//return;
			} else {
				this.makeSalesOrderConfirm(selected_items);
			}
			//console.log('test');
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		setInvoice(invoice) {
			this.so_dn = invoice.so_dn;
		},
		selectInvoice(item) {
			//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: item.invoice_no } });
			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: item.invoice_no } });
			window.open(routeData.href, 'bo_herp_invoice');
		},
		selectSO(item) {
			//this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: item.invoice_no } });
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: item.invoice_no } });
			window.open(routeData.href, 'bo_herp_so');
		},
		selectItem(item) {
			if (this.user.company_id == 'newjigu') {
				let routeData = this.$router.resolve({ name: 'itemInquiry', query: { backUri: this.uri, partner_code: item.ship_to_code, class_code: item.class_code } });
				window.open(routeData.href, 'herp_item_inquiry');
			} else {
				let routeData = this.$router.resolve({ name: 'itemMaster', params: {}, query: { backUri: this.uri, keyword: item.item_id } });
				window.open(routeData.href, 'herp_item');
			}
		},
		selectColor(item) {
			let routeData = this.$router.resolve({ name: 'salesGoods', query: { backUri: this.uri, class_code: item.class_code, color_code: item.color_code } });
			window.open(routeData.href, 'herp_sales_goods');
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectBackOrderItems(pageNo);
		},
		// setSalesGroup(code) {
		// 	if (code) this.sales_group_code = code.code;
		// 	else this.sales_group_code = null;
		// },
		// setPartner(partner) {
		// 	//console.log(partner.code, partner.name);
		// 	if (this.ship_or_bill == 'ship') this.ship_to_code = partner.code;
		// 	else if (this.ship_or_bill == 'bill') this.bill_to_code = partner.code;
		// },
		selectPartner(ship_or_bill) {
			this.ship_or_bill = ship_or_bill;
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			this.invoice_date_from = daysAgo(7);
			this.invoice_date_to = today();
			this.received_date_from = null;
			this.received_date_to = null;
			this.so_dn = null;
			this.sales_group_code = null;
			this.ship_to_code = null;
			this.item_classes_string = '';
			this.item_classes = [];
			this.colors_string = '';
			this.colors = [];
			this.on_hand_q = null;
			this.items_str = '';

			//this.selectInvoices();
			// this.dept_code = null;
		},
		search() {
			if (this.item_classes_string) this.item_classes = this.item_classes_string.split(this.separator);
			else this.item_classes = [];

			if (this.colors_string) this.colors = this.colors_string.split(this.separator);
			else this.colors = [];

			this.selectBackOrderItems();

			if (this.user.company_id == 'beautyplus') {
				this.selectBackOrderTopList();
			}
		},
		async selectBackOrderTopList() {
			var param = {
				invoice_date_from: this.invoice_date_from,
				invoice_date_to: this.invoice_date_to,

				lt_amount: 300,
				top_count: 6,
			};

			const { data } = await apiSelectBackOrderTopList(param);
			this.top_list = data.backOrderTopList;
			var to_fill_count = param.top_count - this.top_list.length;
			for (var i = 0; i < to_fill_count; i++) {
				this.top_list.push({ ship_to_code: null, amount: null });
			}
			//console.log(this.top_list);
		},
		async selectBackOrderItems(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select invoices');
			//const { data } = await selectAllPensioner();
			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				invoice_date_from: this.invoice_date_from,
				invoice_date_to: this.invoice_date_to,
				so_dn: this.so_dn,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,

				color_codes: this.colors,
				item_classes: this.item_classes,
				selected_items: this.selected_items,

				received_date_from: this.received_date_from,
				received_date_to: this.received_date_to,

				on_hand_q: this.on_hand_q,
			};

			const { data } = await apiSelectBackOrderItemList(param);

			let saveParam = {
				invoice_date_from: this.invoice_date_from,
				invoice_date_to: this.invoice_date_to,
				so_dn: this.so_dn,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,

				color_codes: this.colors,
				item_classes: this.item_classes,
				selected_items: this.selected_items,

				received_date_from: this.received_date_from,
				received_date_to: this.received_date_to,

				on_hand_q: this.on_hand_q,
			};

			this.saveParam = objectCopy(saveParam);

			//console.log(data);
			this.items = data.itemList;
			//this.list_count = data.list_count; //data.list_count;
			this.list_count = this.items.length;

			//this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			// var uri = '/sales/back_order?page_no=' + this.page_no;
			// if (this.invoice_date_from) uri += '&invoice_date_from=' + this.invoice_date_from;
			// if (this.invoice_date_to) uri += '&invoice_date_to=' + this.invoice_date_to;
			// if (this.so_dn) uri += '&so_dn=' + this.so_dn;
			// if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			// if (this.ship_to_code) uri += '&ship_to_code=' + this.ship_to_code;
			// if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			// if (this.color_codes) uri += '&color_codes=' + this.color_codes;
			// if (this.item_classes) uri += '&item_classes=' + this.item_classes;
			// if (this.selected_items) uri += '&selected_items=' + this.selected_items;
			// if (this.received_date_from) uri += '&received_date_from=' + this.received_date_from;
			// if (this.received_date_to) uri += '&received_date_to=' + this.received_date_to;
			// this.$router.replace(uri).catch(err => err);
		},
		gotoPartner(code) {
			//console.log(code);
			//this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, code: code } });
			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, code: code } });
			window.open(routeData.href, 'bo_herp_so');
		},
		async index() {
			const { data } = await apiInvoiceIndex();

			this.salesGroups = data.salesGroupList;
		},
		async init() {
			await this.index();

			// if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;
			// if (this.$route.query.invoice_date_from) this.invoice_date_from = this.$route.query.invoice_date_from;
			// if (this.$route.query.invoice_date_to) this.invoice_date_to = this.$route.query.invoice_date_to;
			// if (this.$route.query.so_dn) this.so_dn = this.$route.query.so_dn;
			// if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.ship_to_code) this.ship_to_code = this.$route.query.ship_to_code;
			// if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
			// if (this.$route.query.color_codes) this.color_codes = this.$route.query.color_codes;
			// if (this.$route.query.item_classes) this.item_classes = this.$route.query.item_classes;
			// //if (this.$route.query.selected_items) this.selected_items = this.$route.query.selected_items;
			// if (this.$route.query.received_date_from) this.received_date_from = this.$route.query.received_date_from;
			// if (this.$route.query.received_date_to) this.received_date_to = this.$route.query.received_date_to;

			// // if (this.$route.query.item_classes) {
			// // 	const separator = this.$route.query.separator || this.separator;
			// // 	const items = this.$route.query.items_str.split(separator);
			// // 	this.items_str = items.join(this.separator);
			// // }

			//this.$toast.info('Click "Search" button after setting search condition(s)');
			//await this.selectBackOrderItems(this.$route.query.page_no);
			//await this.selectBackOrderItems();
			this.search();
		},
		async printConfirm() {
			if (this.list_count > 5000) {
				this.$alertify.confirm('If there are more than 5000 items, it may take a long time. Do you want to proceed?', async () => {
					await this.reportPrint();
				});
			} else {
				await this.reportPrint();
			}
		},
		async reportPrint() {
			const { data } = await apiSelectBackOrderItemList(this.saveParam);
			data.from_date = this.saveParam.invoice_date_from;
			data.to_date = this.saveParam.invoice_date_to;
			await reportRender(data, 'BackOrder', reportMrtUrl('BackOrder'));
		},
	},
	created() {
		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_back_order');
		this.$store.commit('setSubTitle', 'Sales -> Back Order');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
